

import { useState } from 'react';
import {
  CartesianGrid,
  Line,
  LineChart,
  ReferenceArea,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { InfoCard } from '../../../../../../shared/ui/designSystem/card';
import { ChartContainer } from '../../../../../../shared/ui/designSystem/chart';
import { RechartsCustomTooltip } from '../../../../../../shared/ui/recharts/recharts';
import { type Listing, orderListingByKms } from '../../../../../modules/listings/domain/listings';
import { ListingComparisonTable } from './ListingComparisonTable';

//  not sure if this make sense, lets try the brusher
const initialState = {
  refAreaLeft: null as string | number | null | undefined,
  refAreaRight: null as string | number | null | undefined,
  left: 'dataMin' as string | number,
  right: 'dataMax' as string | number,
  top: 'dataMax+1' as string | number,
  bottom: 'dataMin' as string | number,
};

export const AnalysisByKms = ({ listings }: { listings: Listing[] }) => {
  const listingsByKms = listings.toSorted(orderListingByKms);
  const findIndexOfSelectedItem = (_: any, v: any) =>
    listingsByKms.findIndex(l => l.id === v.activePayload[0].payload.id)

  const getAxisYDomain = (from: number, to: number, offset: number) => {
    // Filter the listings to only include those within the kms range (for the X-axis)
    const refData = listingsByKms.filter(listing => listing.kms >= from && listing.kms <= to);

    if (refData.length === 0) {
      return [0, 0]; // Return default if no data is found
    }

    // Find the min and max price within the filtered data (for the Y-axis)
    let bottom = refData[0].price;
    let top = refData[0].price;

    refData.forEach((d) => {
      if (d.price > top) top = d.price;
      if (d.price < bottom) bottom = d.price;
    });

    return [(bottom | 0) - offset, (top | 0) + offset];
  };

  const [chartState, setChartState] = useState(initialState);


  const zoom = () => {
    const { refAreaLeft, refAreaRight } = chartState;

    if (!refAreaLeft || !refAreaRight) return;

    const [bottom, top] = getAxisYDomain(refAreaLeft as number, refAreaRight as number, 1000); // Y-axis for price

    setChartState((prevState) => ({
      ...prevState,
      refAreaLeft: null,
      refAreaRight: null,
      left: refAreaLeft,
      right: refAreaRight,
      bottom,
      top,
    }));
  };

  const zoomOut = () => {
    setChartState(initialState);
  };

  const { left, right, refAreaLeft, refAreaRight, top, bottom } = chartState;


  return (
    <section className={'pt-4 pb-16 md:pt-16 px-4 sm:px-8 md:px-12 lg:px-24 xl:px-48'}>
      <InfoCard title={'Analisis por kms'} className={'bg-accent dark:bg-card'}>
        <button type="button" className="btn update" onClick={zoomOut}>
          Zoom Out
        </button>
        <ChartContainer className="max-h-[300px] w-full" config={{}}>
          <LineChart data={listingsByKms} syncId={"id"} syncMethod={findIndexOfSelectedItem}
            onMouseDown={(e) => setChartState((prevState) => ({ ...prevState, refAreaLeft: e.activeLabel }))}
            onMouseMove={(e) =>
              refAreaLeft && setChartState((prevState) => ({ ...prevState, refAreaRight: e.activeLabel }))
            }
            onMouseUp={zoom}>
            <Line type="monotone" dataKey="price" stroke="hsl(var(--chart-1))" yAxisId="1" />
            <CartesianGrid />
            <XAxis allowDataOverflow dataKey="kms" domain={[left, right]} type="number" />
            {/* <XAxis dataKey="kms" tick={FormattedKmsXAxis} tickMargin={8} minTickGap={40} /> */}
            <YAxis allowDataOverflow domain={[bottom, top]} type="number" yAxisId="1" />
            {/* <YAxis tick={FormattedCurrencyYAxis} domain={['auto', 'auto']} /> */}
            <Tooltip content={RechartsCustomTooltip} />
            {refAreaLeft && refAreaRight ? (
              <ReferenceArea yAxisId="1" x1={refAreaLeft} x2={refAreaRight} strokeOpacity={0.3} />
            ) : null}
          </LineChart>
        </ChartContainer>
      </InfoCard>

      <ListingComparisonTable listings={listingsByKms} orderBy="kms" />
    </section>
  );
};
